import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from "react";
import styled, { useTheme } from "styled-components";
import Text from "~/components-shared/Text";
import Button from "~/components-shared/Button";
import mixpanel from "mixpanel-browser";
import { useTranslation } from "react-i18next";
import Card from "~/components-shared/Card";
import Icon from "~/components-shared/Icon";
import { useDispatch, useSelector } from "react-redux";
import onboardingActionCreators from "~/store/onboarding/actions";
import authSelectors from "~/store/auth/selectors";
import { helpers, onboardingOrder } from "~/lib/helpers";
import { StatusStateEnum, MemberStatusEnum, AuthoritiesEnum } from "~/types/enums";
import onboardingSelectors from "~/store/onboarding/selectors";
import { Alert, Box, Modal } from "~/components-shared";
import CompanyIntegrations from "~/components/CompanyIntegrations";
import Markdown from "~/components/Markdown";
import ShareIntegrationsModal from "~/components/ShareIntegrationsModal";
import useAbacExt from "~/hooks/abac";
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const StyledIcon = styled(Icon)`
  box-shadow: inset 0 0 0 6px ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.success.main;
}};
  border-radius: 50%;
`;
const StickyAlert = styled(Alert)`
  position: sticky;
  top: 1em;
  z-index: 2;
`;
const CompanyIntegrationsCard = _ref2 => {
  let {
    open,
    ...rest
  } = _ref2;
  const {
    colors
  } = useTheme();
  const {
    t
  } = useTranslation();
  const user = useSelector(authSelectors.getUser);
  const [shareIntegrations, setShareIntegrations] = useState(false);
  const {
    userHas
  } = useAbacExt();
  const success = user?.status && onboardingOrder[user.status] > onboardingOrder[MemberStatusEnum.ONBOARDING_INTEGRATIONS];
  const dispatch = useDispatch();
  const nextStatus = useSelector(onboardingSelectors.getStatus);
  const backStatus = useSelector(onboardingSelectors.getBackStatus);
  const nextError = useSelector(onboardingSelectors.getError);
  const backError = useSelector(onboardingSelectors.getBackError);
  const availableStatuses = helpers.memberOnboardingStatuses(user.authorities);
  const statusIndex = availableStatuses.findIndex(item => item === user.status);
  const error = nextError || backError;
  const onBack = () => {
    dispatch(onboardingActionCreators.backStarted());
    mixpanel.track(`Onboarding Company Integrations – Back`);
  };
  const onSubmit = () => {
    dispatch(onboardingActionCreators.companyIntegrationsSubmitStarted());
    mixpanel.track(`Onboarding Company Integrations – Submit`);
  };
  const handleShareIntegrations = () => {
    setShareIntegrations(true);
  };
  return /*#__PURE__*/React.createElement(Card, _extends({
    s: {
      px: 10,
      py: 6,
      mb: 10
    },
    collapsed: !open,
    elemAfter: success ? /*#__PURE__*/React.createElement(StyledIcon, {
      src: "checkboxFill",
      scale: 8,
      color: colors.success.main
    }) : undefined,
    shadow: true
  }, rest), /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    s: {
      mb: 4
    },
    fontSize: 4,
    lineHeight: 6,
    display: "block"
  }, t("CompanyIntegrationsCard.description")), userHas(AuthoritiesEnum.ONBOARDING_COMPANY_INTEGRATIONS_WRITE) && /*#__PURE__*/React.createElement(Box, {
    justify: "end",
    s: {
      mb: -4
    },
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Button, {
    elemBefore: /*#__PURE__*/React.createElement(Icon, {
      src: "send",
      s: {
        mr: 2
      }
    }),
    color: "primary",
    s: {
      px: 4,
      py: 2
    },
    fontSize: 3.5,
    onClick: handleShareIntegrations
  }, t("AccountSettings.shareWithIT"))), error && /*#__PURE__*/React.createElement(StickyAlert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(CompanyIntegrations, {
    fullWidth: true
  }), /*#__PURE__*/React.createElement(Markdown, {
    text: t("CompanyIntegrationsCard.requestHere"),
    element: "span",
    color: "textSecondary",
    weight: "regular",
    s: {
      mt: 6,
      mb: 2
    }
  }), /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    gap: 5,
    justify: "end",
    s: {
      mt: 10,
      mb: 2
    },
    fullWidth: true
  }, statusIndex !== 0 && /*#__PURE__*/React.createElement(Button, {
    elemBefore: /*#__PURE__*/React.createElement(Icon, {
      src: "arrow",
      scale: 5,
      rotate: 180,
      s: {
        mr: 2
      }
    }),
    color: "translucent",
    type: "submit",
    onClick: onBack,
    loading: backStatus === StatusStateEnum.LOADING,
    s: {
      pl: 4,
      pr: 6
    },
    rounded: true
  }, t("common.actions.back")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    maxWidth: "230px",
    type: "submit",
    onClick: onSubmit,
    loading: nextStatus === StatusStateEnum.LOADING,
    fullWidth: true,
    rounded: true
  }, t("common.actions.continue")))), /*#__PURE__*/React.createElement(Modal, {
    open: shareIntegrations
  }, /*#__PURE__*/React.createElement(ShareIntegrationsModal, {
    onClose: () => setShareIntegrations(false)
  })));
};
export default CompanyIntegrationsCard;